import { BUTTON } from '../classnames';

export const ICON_BUTTON_BASE_XS = `${BUTTON} w-32 h-32 flex-shrink-0`;

export const ICON_BUTTON_XS = `${ICON_BUTTON_BASE_XS} cursor-pointer`;

export const ICON_BUTTON_DISABLED_XS = `${ICON_BUTTON_BASE_XS} cursor-default pointer-events-none`;

export const ICON_BUTTON_BASE = (responsive?: boolean) =>
  `${BUTTON} border border-solid ${
    responsive ? 'sm:w-48 sm:h-48' : 'flex-shrink-0 w-48 h-48'
  }`;

export const ICON_BUTTON = (responsive?: boolean) =>
  `${ICON_BUTTON_BASE(responsive)} ${
    responsive
      ? `${ICON_BUTTON_XS} border-transparent sm:border-gray-light sm:hover:border-primary-main`
      : 'cursor-pointer border-gray-light active:border-primary-main sm:hover:border-primary-main'
  }`;
export const ICON_BUTTON_WHITE = (responsive?: boolean) =>
  `${ICON_BUTTON_BASE(responsive)} ${
    responsive
      ? `${ICON_BUTTON_XS} border-transparent sm:border-gray-dark sm:hover:border-white`
      : 'cursor-pointer border-gray-dark active:border-white sm:hover:border-white'
  }`;
export const ICON_BUTTON_DARK_MODE = (responsive?: boolean) =>
  `${ICON_BUTTON_BASE(responsive)} ${
    responsive
      ? `${ICON_BUTTON_XS} border-transparent sm:border-gray-dark sm:hover:border-secondary-light`
      : 'cursor-pointer border-gray-dark active:border-secondary-light sm:hover:border-secondary-light'
  }`;

export const ICON_BUTTON_DISABLED = (responsive?: boolean) =>
  `${ICON_BUTTON_BASE(responsive)} ${
    responsive
      ? `${ICON_BUTTON_DISABLED_XS} border-transparent pointer-events-none`
      : 'cursor-default border-transparent pointer-events-none'
  }`;

export default {
  default: ICON_BUTTON,
  white: ICON_BUTTON_WHITE,
  darkMode: ICON_BUTTON_DARK_MODE,
  'default-disabled': ICON_BUTTON_DISABLED,
  'white-disabled': ICON_BUTTON_DISABLED,
  'darkMode-disabled': ICON_BUTTON_DISABLED,
  'default-xs': () => ICON_BUTTON_XS,
  'white-xs': () => ICON_BUTTON_XS,
  'darkMode-xs': () => ICON_BUTTON_XS,
  'default-xs-disabled': () => ICON_BUTTON_DISABLED_XS,
  'white-xs-disabled': () => ICON_BUTTON_DISABLED_XS,
  'darkMode-xs-disabled': () => ICON_BUTTON_DISABLED_XS,
};
